import { AxiosProgressEvent } from 'axios';
import { download, get } from '../../resource-base/APIVersion1';
import { onUnauthorizedWithoutHook } from '../../resource-base/adapters/AdapterUtils';

export class ExporterService {
    actions() {
        return ExporterServiceActions();
    }
}

function ExporterServiceActions() {
    const handleExporterResultWithBoolean = (result: Response, errorMessage: string) => {
        if (result.status === 200) {
            return true;
        } else if (result.status === 401) {
            return onUnauthorizedWithoutHook(result, false);
        }
        return Promise.reject(errorMessage);
    };

    const startDownloadPVT = (name: string, projectVersionId: string): Promise<boolean> => {
        const errorMessage = 'Could not download the exported ProCeed file of the Project Version!';
        return get(`exporter/start-export-to-pvt/${projectVersionId}?file-name=${name}`).then(
            (result) => handleExporterResultWithBoolean(result, errorMessage),
            (_) => Promise.reject(errorMessage)
        );
    };

    const startDownloadRichText = (name: string, processAreaId: string, projectVersionId: string): Promise<boolean> => {
        const errorMessage = 'Could not export the rich text of the Process Area!';
        return get(
            `exporter/start-export-to-richtext/${processAreaId}?file-name=${name}&project-version=${projectVersionId}`
        ).then(
            (result) => handleExporterResultWithBoolean(result, errorMessage),
            (_) => Promise.reject(errorMessage)
        );
    };

    const startDownloadPVTOfLatestVersion = (name: string, projectId: string): Promise<boolean> => {
        const errorMessage = 'Could not download the exported ProCeed file of the Project!';
        return get(`exporter/start-export-latest-version-to-pvt/${projectId}?file-name=${name}`).then(
            (result) => handleExporterResultWithBoolean(result, errorMessage),
            (_) => Promise.reject(errorMessage)
        );
    };

    const downloadFromBackgroundTask = (
        name: string,
        backgroundTaskId: string,
        fileType: 'pvt' | 'zip' | 'html',
        onDownloadProgress?: (progressEvent: AxiosProgressEvent) => void
    ) => {
        const errorMessage = 'Could not download file!';
        return download(`exporter/download-file-from-background-task/${backgroundTaskId}`, onDownloadProgress).then(
            (result) => {
                if (result.status === 200) {
                    const blob = result.data;
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = url;
                    a.download = `${name}.${fileType}`;
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                    return result.data;
                }
                return Promise.reject(errorMessage);
            },
            (_) => Promise.reject(errorMessage)
        );
    };

    return {
        startDownloadRichText,
        startDownloadPVT,
        startDownloadPVTOfLatestVersion,
        downloadFromBackgroundTask,
    };
}
